// 运行时兜底补丁：
// 某些打包结果下 @wk/components-react16 的 “index -> library” 导出链路可能丢失。
// 这里统一将 library 的导出回填到 index 模块，避免运行时 undefined / is not a function。
const patchFromLibrary = (modulePath, requiredExports = []) => {
  try {
    // eslint-disable-next-line global-require
    const indexModule = require(modulePath);
    // eslint-disable-next-line global-require
    const libraryModule = require(`${modulePath}/library`);

    let patched = false;
    Object.keys(libraryModule || {}).forEach((key) => {
      if (typeof indexModule?.[key] === "undefined") {
        indexModule[key] = libraryModule[key];
        patched = true;
      }
    });

    const missingRequired = requiredExports.filter(
      (key) => typeof indexModule?.[key] === "undefined"
    );

    if (patched) {
      // eslint-disable-next-line no-console
      console.warn(`[wkRuntimePatch] patched exports from ${modulePath}/library`);
    }

    if (missingRequired.length > 0) {
      // eslint-disable-next-line no-console
      console.error(
        `[wkRuntimePatch] required exports still missing in ${modulePath}: ${missingRequired.join(", ")}`
      );
    }
  } catch (error) {
    // 不阻断主流程，只记录补丁执行异常
    // eslint-disable-next-line no-console
    console.error(`[wkRuntimePatch] patch failed for ${modulePath}:`, error);
  }
};

// 关键模块：组件状态写入与 className 计算
patchFromLibrary("@wk/components-react16/dist/component-api-lib", ["componentApi"]);
patchFromLibrary("@wk/components-react16/dist/lib-classNames", ["classNames"]);
